import React, { createContext, useContext } from 'react'

const ValidationSchemaContext = createContext({
  schema: null
})

export function ValidationSchemaProvider ({ schema, children }) {
  return (
    <ValidationSchemaContext.Provider value={{ schema }}>
      {children}
    </ValidationSchemaContext.Provider>
  )
}

export function useValidationSchema () {
  const { schema } = useContext(ValidationSchemaContext)
  return { schema }
}
